import React from 'react';
import styled from 'styled-components';

interface ISparklineProps {
  values: Array<number | null | undefined>;
  height?: number;
  color?: string;
  // Internal viewBox width — visual scaling is via CSS width: 100%.
  viewWidth?: number;
}

const Wrap = styled.span`
  display: block;
  width: 100%;
  line-height: 0;
`;

const Sparkline: React.FC<ISparklineProps> = ({
  values,
  height = 24,
  color = '#00B27B',
  viewWidth = 100
}) => {
  const clean = values.filter((v): v is number => typeof v === 'number');

  if (clean.length < 2) {
    return <span style={{ color: 'rgba(0,0,0,0.35)', fontSize: 11 }}>—</span>;
  }

  const min = Math.min(...clean);
  const max = Math.max(...clean);
  const range = max - min || 1;
  const stepX = clean.length > 1 ? viewWidth / (clean.length - 1) : 0;

  const points = clean
    .map((v, i) => `${i * stepX},${height - ((v - min) / range) * height}`)
    .join(' ');

  return (
    <Wrap>
      <svg
        viewBox={`0 0 ${viewWidth} ${height}`}
        preserveAspectRatio='none'
        width='100%'
        height={height}
      >
        <polyline
          fill='none'
          stroke={color}
          strokeWidth={1.5}
          vectorEffect='non-scaling-stroke'
          points={points}
        />
      </svg>
    </Wrap>
  );
};

export default Sparkline;
